import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ContentComponent } from "@app/main/content/game-settings/popup/content/content.component";
import { FormGroup } from "@angular/forms";
import { PopupModel } from "@app/main/content/game-settings/popup/popup.model";
import { Reward } from "@app/main/content/game-settings/popup/content/reward.model";
import { Embed } from "@app/main/content/game-settings/popup/content/embed.model";
import { AdFormComponent } from "@app/main/content/game-settings/ad-form/ad-form.component";
import { ContentModel } from "@app/main/content/game-settings/popup/content/content.model";
import * as _ from "lodash";
import { environment } from "@env/environment";
import { HelperService } from "@app/main/core/services/helper.service";
import { AdminApi } from "@app/shared/sdk";
import { MatSnackBar } from "@angular/material";
import { SurveyModel } from "../ad-form/survey.model";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GameSettingsService } from "../game-settings.service";

@Component({
  selector: "app-popup",
  templateUrl: "./popup.component.html",
  styleUrls: ["./popup.component.scss"],
})
export class PopupComponent implements OnInit, AfterViewInit, OnChanges {
  data: any;
  dialogRef: any;
  @Input("data") dataFromGameSettings: any;
  @Output() popupEvent = new EventEmitter<any>();
  popup: PopupModel = new PopupModel();

  // Private
  private _unsubscribeAll: Subject<any>;

  constructor(
    private dialog: MatDialog,
    private helperService: HelperService,
    private adminApi: AdminApi,
    private snackBar: MatSnackBar,
    private fuseSplashScreenService: FuseSplashScreenService,
    private gameSettingsService: GameSettingsService
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  /**
   * Life Cycle hook
   */

  ngOnInit() {
    this.data = this.dataFromGameSettings;
  }

  ngAfterViewInit() {}

  /**
   *
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.dataFromGameSettings.currentValue) {
      this.data = changes.dataFromGameSettings.currentValue;
    } else {
      this.data = changes.dataFromGameSettings.previousValue;
    }
  }

  /**
   * Public Methods
   */

  /**
   *
   * @param data
   */
  openAdmobDialog(data) {
    if (
      _.isEmpty(data.popup["popUp" + data.index]) ||
      data.popup["popUp" + data.index].content
    ) {
      this.popup = data.popup["popUp" + data.index];
    }
    this.dialogRef = this.dialog.open(AdFormComponent, {
      panelClass: "ad-form-dialog",
      height: "auto",
      width: "690px",
      data: {
        action:
          _.isEmpty(data.popup["popUp" + data.index]) ||
          !data.popup["popUp" + data.index].type
            ? "new"
            : "edit",
        popup: data.popup["popUp" + data.index],
        gameCategoryId: data.gameCategoryId,
        ques: data.ques,
        survey: data.survey ? data.survey : new SurveyModel(),
      },
    });

    this.dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: FormGroup) => {
        if (!response) {
          return;
        }
        const formData = response.getRawValue();

        formData.popupType = formData.popupType.toLocaleLowerCase();
        this.popup.type = formData.popupType;

        if (this.popup.type === "survey") {
          if (formData.survey) {
            data.survey = {};
            data.survey = formData.survey;

            /**
             * * if displayType is not set to vertical for index === 0
             * * then set it manually to vertical
             */
            if (data.survey.tabIndex === 0)
              data.survey.displayType = "vertical";

            let files = [];

            files.push({ file: data.survey.image.file, type: "survey-image" });

            files = [
              ...files,
              ...data.survey.choices.map((el) => ({
                file: el.image.file,
                type: el.label,
              })),
            ];
            let uploadPath = `${environment.mainContainer}/${environment.surveyUploadPath}`;

            files = files.filter((el) => el.file !== undefined);

            if (files && files.length !== 0) {
              this.fuseSplashScreenService.show();
              this.helperService
                .uploadFile(
                  files,
                  uploadPath,
                  this.adminApi.getCurrentToken().id
                )
                .then(
                  (response) => {
                    response.forEach((el) => {
                      if (el && el.type === "survey-image") {
                        delete data.survey.image.file;
                        data.survey.image.src =
                          el.src.result.files["file"][0][
                            "providerResponse"
                          ].name;
                      }
                      if (
                        data.survey.choices &&
                        data.survey.choices.length !== 0
                      ) {
                        data.survey.choices.forEach((choice) => {
                          if (choice.image.file && choice.label === el.type) {
                            delete choice.image.file;
                            choice.image.src =
                              el.src.result.files["file"][0][
                                "providerResponse"
                              ].name;
                          }
                        });
                      }
                    });
                    this.fuseSplashScreenService.hide();
                  },
                  (error) => {
                    this.fuseSplashScreenService.hide();
                    this.snackBar.open(error.error.error.message, "ERROR", {
                      verticalPosition: "top",
                      duration: 3000,
                    });
                  }
                );
            }
          }

          formData.survey.comments = formData.survey.comments
            // Filter out elements where the question is an empty string
            .filter(({ question }) => question !== "")
            .map(({ question, comments }) => {
              // Filter out comments with empty values and map to their value
              const filteredComments = comments
                .filter(({ value }) => value !== "") // Keep only comments with non-empty values
                .map(({ value }) => value); // Map to comment values

              // Return the new object with question and filtered comments
              return { question, comments: filteredComments };
            })
            // Optionally filter out questions with no valid comments left after filtering
            .filter(({ comments }) => comments.length > 0);

          this.popup.data = formData.survey;
        } else if (this.popup.type === "ad") {
          if (this.popup.data) this.popup.data = {};
        } else if (this.popup.type === "admob") {
          this.popup.content = {};
          this.popup.data = {};
        } else if (this.popup.type === "que" || this.popup.type === "adque") {
          // this.popup.type = "adque";
          this.popup.data = formData.data;
        }
        this.gameSettingsService.isDuplicationFlag = true;
        this.sendPopup();
      });
  }

  sendPopup() {
    this.popup.position = this.data.index + 1;
    this.popupEvent.emit(this.popup);
  }

  /**
   *
   * @param data
   */
  openContentDialog(data) {
    if (
      _.isEmpty(data.popup["popUp" + data.index]) ||
      data.popup["popUp" + data.index].content
    ) {
      this.popup = data.popup["popUp" + data.index];
    }
    this.dialogRef = this.dialog.open(ContentComponent, {
      panelClass: "content-form-dialog",
      height: "auto",
      width: "690px",
      data: {
        action:
          _.isEmpty(data.popup["popUp" + data.index]) ||
          !data.popup["popUp" + data.index].content
            ? "new"
            : "edit",
        popup: data.popup["popUp" + data.index],
        gameCategoryId: data.gameCategoryId,
        ques: data.ques,
      },
    });
    this.dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(async (response: FormGroup) => {
        if (response) {
          const formData = response.getRawValue();
          formData.type = formData.type
            ? formData.type.toLocaleLowerCase()
            : "url";
          if (!this.popup.content) this.popup.content = new ContentModel();
          this.popup.content.type = formData.type;
          if (formData.type === "url") {
            if (this.popup.content.embed) {
              this.popup.content.embed = new Embed();
            }
            if (this.popup.content.reward) {
              this.popup.content.reward = new Reward();
            }
            this.popup.content.data = {
              link: formData.url,
              // thumbnail: formData.urlThumbnail
            };
          } else if (formData.type === "embed") {
            if (this.popup.content.data) {
              this.popup.content.data = {};
            }
            if (this.popup.content.reward) {
              this.popup.content.reward = new Reward();
            }

            formData.embededCode = this.changeWidthHeightOfEmbedCode(
              formData.embededCode
            );

            this.popup.content.embed = {
              title: formData.videoTitle,
              code: formData.embededCode,
              description: formData.videoInfo,
              // thumbnail: formData.embedThumbnail
            };
          } else if (formData.type === "reward") {
            if (this.popup.content.data) {
              this.popup.content.data = {};
            }
            if (this.popup.content.embed) {
              this.popup.content.embed = new Embed();
            }
            this.popup.content.reward = {
              type: formData.rewardType ? "positiveReward" : "negativeReward",
              data: {
                isUrl: formData.isUrl,
                url: formData.rewardUrl,
                coinIcon: formData.rewardThumbnail || "",
                points: formData.points ? Number(formData.points) : 0,
                isExpand: formData.isExpand || false,
                background: {
                  image: formData.rewardBackground || "",
                  color1: formData.rewardColor1 || "",
                  color2: formData.rewardColor2 || "",
                  scale: formData.backgroundScale || 1
                },
                thumbnail: {
                  image: formData.rewardArt || "",
                  scale: formData.thumbnailScale || 1
                },
                counter: {
                  counterColor1: formData.counterColor1 || "",
                  counterColor2: formData.counterColor2 || ""
                }
              },
            };

          } else if (formData.type === "que") {
            if (this.popup.content.embed) {
              this.popup.content.embed = new Embed();
            }
            if (this.popup.content.reward) {
              this.popup.content.reward = new Reward();
            }
            this.popup.content.data = {
              player: {
                id: formData.playerId,
                profileImage: formData.playerImage,
              },
              url: formData.queUrl,
              id: formData.selectedQueId,
              quePos: formData.selectedQuePosition,
            };
          } else if (formData.type === "image") {
            this.fuseSplashScreenService.show();
            this.popup.content.data = formData.imageFormData;
            await this.uploadImage(
              this.popup.content.data.backgroundImage.file,
              this.gameSettingsService.thumbnailUploadPath,
              "backgroundImage"
            );
            await this.uploadImage(
              this.popup.content.data.image.file,
              this.gameSettingsService.thumbnailUploadPath,
              "image"
            );
            this.fuseSplashScreenService.hide();
          }
          this.sendPopup();
        }
      });
  }

  changeWidthHeightOfEmbedCode(embedCode) {
    embedCode = embedCode.split(" ");

    if (embedCode.length !== 0) {
      embedCode.forEach((el, index) => {
        if (el.indexOf("width") !== -1) {
          embedCode[index] = `width="100%"`;
        } else if (el.indexOf("height") !== -1) {
          embedCode[index] = `height="100%"`;
        }
      });
    }
    return embedCode.join(" ");
  }

  uploadImage(file, uploadPath: string, type: "image" | "backgroundImage") {
    this.gameSettingsService
      .upload(file, uploadPath, this.adminApi.getCurrentToken().id)
      .then(
        (response: any) => {
          this.popup.content.data[type].imgSrc = response.result.files["file"][0]["providerResponse"].name;
          this.popup.content.data[type].backgroundImageSrc = response.result.files["file"][0]["providerResponse"].name;
          delete this.popup.content.data[type].file;
        },
        (error) => {
          this.fuseSplashScreenService.hide();
        }
      );
  }

  /**
   *
   * @param index
   */
  isContent(index) {
    return (
      this.data.popup["adType" + index] === "ad" ||
      this.data.popup["adType" + index] !== "manad"
    );
  }
}
